import { useState } from "react";
import { camelizeKeys, snakifyKeys } from "../../../../util/helpers";
import { api, extractErrorMessage } from "../../../../util/api";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { Form } from "react-final-form";
import { PreprocessingCategoryForm } from "./PreprocessingCategoryForm";

export const EditPreprocessingCategory = ({ preprocessingCategory, onUpdate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleUpdate = async (params) => {
    try {
      const res = await api.patch(`/admin/preprocessing_categories/${preprocessingCategory.id}`, {
        preprocessing_category: snakifyKeys(params),
      });

      if (onUpdate) {
        onUpdate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Edit
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Preprocessing Category</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleUpdate} initialValues={camelizeKeys({ ...preprocessingCategory })}>
            {(props) => <PreprocessingCategoryForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
